// Data da escritura de um negócio, em três situações que se distinguem à vista:
// - Limite: prazo do CPCV, ainda sem escritura marcada (cinzento; amarelo a 30 dias; vermelho se passou)
// - Agendada: escritura marcada com dia certo (linha azul; vermelho se a data passou sem confirmação)
// - Realizada: confirmada (verde)
// Não precisa de campos novos: "cpcv_assinado" → a data guardada é o limite; "escritura_agendada" → é a marcação.
const CONCLUIDO = ["escriturado", "vendido", "arrendado", "fechado"];
export const DIAS_AVISO_LIMITE = 30;
const fmtData = (d) => new Date(d).toLocaleDateString("pt-PT");
const diasAte = (d) => Math.round((new Date(String(d).slice(0, 10) + "T00:00:00") - new Date(new Date().toDateString())) / 86400000);

export function estadoEscritura(n) {
  if (!n || n.estado === "cancelado") return null;
  const arr = n.tipo === "arrendamento";
  if (n.data_escritura_realizada || n.escritura_concluida || CONCLUIDO.includes(n.estado)) {
    const data = n.data_escritura_realizada || n.data_escritura_agendada;
    return data ? { tipo: "realizada", data, texto: `✓ ${arr ? "Assinado" : "Realizada"} ${fmtData(data)}`, titulo: arr ? "Contrato assinado" : "Escritura realizada" } : null;
  }
  if (!n.data_escritura_agendada) return null;
  const data = n.data_escritura_agendada;
  const dias = diasAte(data);
  if (n.estado === "escritura_agendada") {
    const quando = dias < 0 ? `atrasada ${-dias} dia${dias === -1 ? "" : "s"}` : dias === 0 ? "hoje" : dias === 1 ? "amanhã" : `faltam ${dias} dias`;
    return { tipo: "agendada", data, dias, atraso: dias < 0, texto: `🗓 Agendada ${fmtData(data)}`, sub: quando, titulo: arr ? "Contrato agendado" : "Escritura agendada" };
  }
  const quando = dias < 0 ? `passou há ${-dias} dia${dias === -1 ? "" : "s"}` : dias === 0 ? "termina hoje" : `faltam ${dias} dias`;
  return { tipo: "limite", data, dias, atraso: dias < 0, perto: dias >= 0 && dias <= DIAS_AVISO_LIMITE, texto: `Limite ${fmtData(data)}`, sub: quando, titulo: arr ? "Data limite do contrato" : "Data limite da escritura (prazo do CPCV)" };
}

const ESTILOS = {
  limite: { color: "#4b5563", background: "#e5e7eb", border: "1.5px solid #e5e7eb" },
  perto: { color: "#92400e", background: "#fef3c7", border: "1.5px solid #d97706" },
  atraso: { color: "#b91c1c", background: "#fee2e2", border: "1.5px solid #dc2626" },
  agendada: { color: "#12244f", background: "#fff", border: "1.5px solid #2563eb" },
  realizada: { color: "#15803d", background: "#dcfce7", border: "1.5px solid #dcfce7" },
};

export function EtiquetaEscritura({ n, comDias = true, tamanho = 11.5 }) {
  const e = estadoEscritura(n);
  if (!e) return <span style={{ color: "#9ca3af" }}>—</span>;
  const estilo = e.atraso ? ESTILOS.atraso : e.perto ? ESTILOS.perto : ESTILOS[e.tipo];
  return (
    <span title={e.titulo} style={{ display: "inline-flex", alignItems: "center", gap: 5, borderRadius: 999, padding: "2px 10px", fontSize: tamanho, fontWeight: 700, whiteSpace: "nowrap", fontVariantNumeric: "tabular-nums", ...estilo }}>
      {e.texto}{comDias && e.sub ? <span style={{ fontWeight: 500 }}>· {e.sub}</span> : null}
    </span>
  );
}
